//@ts-check
import React from "react";
import { endPoint } from "src/AppConstants";
import classes from "./ImagePicker.module.scss";
import useTypedSelector from "utils/useTypedSelector";
import { useI18n } from "components/lni18n";

/**
 * 
 * @param {{images: import("./ImagePicker_types").ImagePickerImageDto[], onClick: Function}} props 
 * @returns 
 */
const ImageList = ({ images, onClick }) => {

    const { languageService: t } = useI18n();
    const { user } = useTypedSelector(state => state.login);

    const getImageUrl = (image) => {
        if (image.ThumbUrl) {
            return image.ThumbUrl;
        } else if (image.ImageId) {
            return endPoint.GET_IMAGE_THUMB_URL(image.ImageId);
        }
        return "";
    }

    return <>

        <div className="pl-5 my-4 d-flex ">
            <div className="d-flex mr-5">
                <div className="position-relative mt-2 mr-3">
                    &nbsp;&nbsp;
                    <div className="green-mark-right small-mark">

                    </div>
                </div> {t.getText("images.mine")}
            </div>

            <div className="d-flex mr-5">
                <div className="position-relative mt-2 mr-3">
                    &nbsp;&nbsp;
                    <div className="red-mark-right small-mark">

                    </div>
                </div> {t.getText("in.use")}
            </div>


        </div>


        <div className={classes.imgList} >
            {images.map(i => {
                return <div key={i.ImageId} onClick={() => onClick(i.ImageId)} className={"m-2 pointer " + classes.thumbBox} id={"img" + i.ImageId}>
                    <img src={getImageUrl(i)} alt="" />
                    {i.HaveReferences && <div className="red-mark-right small-mark"></div>}
                    {i.User.Id === user.Id && <div className="green-mark-right small-mark"></div>}


                </div>
            })}
        </div>

    </>
}

export default ImageList;
